import styled, { css } from 'styled-components/macro';
import { linkStyling } from 'styles/base-classes';

import Box from 'components/elements/Box';

export const ColorfulLink = styled('a')<{ isSmall?: boolean }>`
  width: ${({ isSmall }): string => (isSmall ? '155px' : '300px')};
  margin-top: 1.5rem;
  padding: 0.5rem 0;
  background-color: ${({ theme }): string => theme.AccentGreen};
  text-align: center;
  border-radius: 3px;

  @media screen and (max-width: 66rem) {
    margin: 1.7rem auto 0;
    font-size: 1rem;
  }
`;

const ReferenceStyle = ({ theme }: any): any => css`
  a {
    font-weight: 500;
    box-shadow: none;
    cursor: pointer;

    &:not(${ColorfulLink}) {
      width: fit-content;

      &:hover {
        box-shadow: none;
      }
      &:focus,
      &:active {
        background: none;
        color: ${theme.White};
        box-shadow: 0px 3px 0px 0px ${theme.AccentGreen};
      }
    }
  }
`;

export const Links = styled('div')`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-flow: column nowrap;
  width: 100%;
  position: relative;
  padding: 1.2em 0;
  font-size: 13px;
  color: ${({ theme }): string => theme.CasperGrey};

  a,
  span {
    outline-color: white;
  }

  ${ReferenceStyle};

  @media screen and (min-width: 50em) {
    flex-flow: row nowrap;
  }

  > * {
    @media screen and (max-width: 50em) {
      margin: 0.2em 0;
    }

    @media screen and (min-width: 50em) {
      margin: ${({ theme }): string => `0 ${theme.spacing.large};`};
    }

    @media screen and (min-width: 95em) {
      margin: ${({ theme }): string => `0 ${theme.spacing.medium};`};
    }
  }
`;

export const StyledFooter = styled('footer')`
  background: ${({ theme }): string => theme.DeepBlue};
  width: 100%;
`;

export const Copyright = styled.span`
  text-decoration: none;
  color: inherit;
  position: relative;
  padding-bottom: 0;

  @media screen and (max-width: 50em) {
    margin-bottom: 1em;
  }
`;

export const StyledLink = styled('a')`
  ${linkStyling};
  padding-bottom: 0;
  cursor: pointer;
`;

export const FooterFrame = styled('footer')`
  background-color: #000b28;
  border-width: 0 0 4px;
  border-style: solid;
  border-image: linear-gradient(
      90deg,
      ${({ theme }): string => theme.GradientBlue},
      ${({ theme }): string => theme.GradientGreen}
    )
    50;

  ${ReferenceStyle};

  a {
    font-size: 0.875rem;
    text-decoration: none;
    color: ${({ theme }): string => theme.White};

    @media screen and (max-width: 66rem) {
      font-size: 1rem;
    }
  }
`;

export const Logo = styled('img')`
  width: 6rem;
  margin-bottom: 5px;

  @media screen and (max-width: 66rem) {
    margin: 0 auto;
  }
`;

export const ColumnBox = styled(Box)<{ isSmallScreen?: boolean }>`
  display: flex;
  flex-direction: column;
  flex-basis: calc(100% / 5);
  align-items: ${({ isSmallScreen }): string =>
    isSmallScreen ? 'center' : 'initial'};

  &:not(:last-child) {
    padding-bottom: ${({ isSmallScreen }): string =>
      isSmallScreen ? '2.5rem' : '0'};
  }
`;

export const FooterBannerBox = styled(Box)`
  border-width: 4px 0 0;
  border-style: solid;
  border-image: linear-gradient(
      90deg,
      ${({ theme }): string => theme.GradientBlue},
      ${({ theme }): string => theme.GradientGreen}
    )
    50;
`;
